const ltcpRoutes = {
  HOME: "/",
  LANDING: "/ltcp/landing",
  DASHBOARD: "/ltcp/dashboard/overview",
  UPLOADS: "/ltcp/dashboard/uploads",
  SIMULATION: "/ltcp/dashboard/simulation",
  REPORTS: "/ltcp/dashboard/reports",
  CU: "/ltcp/dashboard/cu",
  DEMAND: "/ltcp/dashboard/demand",
  CAPACITY: "/ltcp/dashboard/capacity",
  ALERTS: "/ltcp/dashboard/alerts",
  RECOMMENDATION: "/ltcp/dashboard/recommendation",
  ROLES: "/ltcp/dashboard/roles",
};

export default ltcpRoutes;
